/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ShipmentsInputs */

const en_nav_shipments = /** @type {(inputs: Nav_ShipmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipments`)
};

/**
* | output |
* | --- |
* | "Shipments" |
*
* @param {Nav_ShipmentsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_shipments = /** @type {((inputs?: Nav_ShipmentsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ShipmentsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_shipments(inputs)
});